export default __webpack_public_path__ + "static/08edde9d-c27b-4731-a27f-d6cd9b01cd06-ab52e8bbc3b64f5d6aa139f239206bb7.woff";